/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import ImportArticlesApi from '../api/ImportArticle';
import { ERROR_CODES } from '../constants/ApiErrorConstants';
import { makeGetProgress } from '../import/actions/ImportActions';
import * as ActionTypes from './ActionTypes';
export const getImportArticlesProgress = makeGetProgress(ImportArticlesApi.getProgress);
export function getImportWarningsAndDownloadLink() {
  return dispatch => {
    dispatch({
      type: ActionTypes.FETCH_IMPORT_WARNING_AND_DOWNLOAD_LINK_PENDING
    });
    return Promise.all([ImportArticlesApi.getImportWarningsCount(), ImportArticlesApi.getAlteredArticlesDownloadLink()]).then(([count, alteredArticlesListLink]) => dispatch({
      payload: {
        count,
        alteredArticlesListLink
      },
      type: ActionTypes.FETCH_IMPORT_WARNING_AND_DOWNLOAD_LINK_SUCCESS
    }), error => {
      if (error.status === ERROR_CODES.NOT_FOUND) {
        dispatch({
          payload: {
            count: 0
          },
          type: ActionTypes.FETCH_IMPORT_WARNING_AND_DOWNLOAD_LINK_SUCCESS
        });
      } else {
        dispatch({
          error,
          type: ActionTypes.FETCH_IMPORT_WARNING_AND_DOWNLOAD_LINK_ERROR
        });
      }
    });
  };
}
export function resetImportWarningsAndDownloadLink() {
  return {
    type: ActionTypes.RESET_IMPORT_WARNING_AND_DOWNLOAD_LINK
  };
}
export function getImportedArticleNeedsReview(articleId) {
  return dispatch => {
    dispatch({
      type: ActionTypes.FETCH_IMPORTED_ARTICLE_NEEDS_REVIEW_PENDING
    });
    ImportArticlesApi.getImportedArticleNeedsReview(articleId).then(payload => dispatch({
      payload,
      type: ActionTypes.FETCH_IMPORTED_ARTICLE_NEEDS_REVIEW_SUCCESS
    }), error => {
      if (error.status === ERROR_CODES.NOT_FOUND) {
        dispatch({
          payload: false,
          type: ActionTypes.FETCH_IMPORTED_ARTICLE_NEEDS_REVIEW_SUCCESS
        });
      } else {
        dispatch({
          error,
          type: ActionTypes.FETCH_IMPORTED_ARTICLE_NEEDS_REVIEW_ERROR
        });
      }
    });
  };
}
export function reviewImportedArticle(articleId) {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_IMPORTED_ARTICLE_NEEDS_REVIEW_PENDING
    });
    return ImportArticlesApi.reviewImportedArticle(articleId).then(payload => dispatch({
      payload,
      type: ActionTypes.UPDATE_IMPORTED_ARTICLE_NEEDS_REVIEW_SUCCESS
    }), error => {
      dispatch({
        error,
        type: ActionTypes.UPDATE_IMPORTED_ARTICLE_NEEDS_REVIEW_ERROR
      });
    });
  };
}